import { create } from "zustand"

export default create((set) => (
	{
		totalRO: 0,
		setTotalRO: (number) => set((state) => ({
			totalRO: number
		})),


		unassignedRO: 0,
		setUnassignedRO: (number) => set((state) => ({
			unassignedRO: number
		})),

		jurisdictionName: 'Select a jurisdiction',
		setJurisdictionName: (name) => set((state) => ({
			jurisdictionName: name
		})),

		currentQCUsers: [],
		setCurrentQCUsers: (qcUsers) => set((state) => ({
			currentQCUsers: qcUsers
		})),

		/* {
			id, quantity
		} */
		selectedQCUsers: [],
		addSelectedQCUser: (qcUser) => set((state) => {
			if (state.selectedQCUsers.find((selectedQCUser) => selectedQCUser.id === qcUser.id)) {
				// if qcUser already exists, set the quantity to the new quantity
				// set quantity
				return {
					selectedQCUsers: state.selectedQCUsers.map((selectedQCUser) => {
						if (selectedQCUser.id === qcUser.id) {
							return {
								...selectedQCUser,
								quantity: qcUser.quantity
							}
						}

						return selectedQCUser
					})
				}
			} else {
				// else add the qcUser to the array
				return {
					selectedQCUsers: [
						...state.selectedQCUsers,
						qcUser
					]
				}
			}
		}),
		removeSelectedQCUser: (qcUser) => set((state) => ({
			selectedQCUsers: state.selectedQCUsers.filter((selectedQCUser) => selectedQCUser.id !== qcUser.id)
		})),
		setSelectedQCUsers: (qcUsers) => set((state) => ({
			selectedQCUsers: qcUsers
		})),
		resetSelectedQCUsers: () => set((state) => ({
			selectedQCUsers: []
		}))
	}
))

